module.exports = __webpack_public_path__ + "img/geology-jupiter.999d3f72.png";